import { SlotGameType1_2_2Screen } from "../SlotGameType1_2_2Screen";
import { Scale} from "../.././MyHelpers";
import { IReadOnlyResourceManager, LoadingStage, ResourceManager } from "../../ResourceManager/ResourceManager";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { FontResource } from "../../ResourceManager/FontResource";
import { FreegameBonusFactory2 } from "../FreegameBonus/FreegameBonus2";
import { FreegameBonusFactory2_2screen , FreegameBonus2_2Screen } from "../FreegameBonus/FreegameBonus2_2Screen";
import { FreegamesCommonConfiguration } from "../../api";
import { FreegameBonus2Params , FreegameBonus2 } from "../FreegameBonus/FreegameBonus2";
import { SlideFactory } from "../Slider/SecondScreenHelp";
// namespace SlotGames2 {
	export class SevenForever2_2Screen extends SlotGameType1_2_2Screen
	{
	
	//	protected freegameBonusFactory: FreegameBonusFactory2 = new SevenForeverFreegame2BonusFactory();
	protected slideFactory: SlideFactory = new SevenForeverSecondScreenHelpFactory();

	protected freegameBonusFactory_2screen: FreegameBonusFactory2_2screen = new SevenForeverFreegame2BonusFactory_2Screen();

	protected override PaytableLoaded(resourceManager: IReadOnlyResourceManager): void 
	{
	}
}



class SevenForever2Freegame_2Screen extends FreegameBonus2
{
	public override async PrepareFonts(resourceManager: ResourceManager)
	{
			//resourceManager.Add(new FontResource(this.basepath + "resources/huggable.ttf", "." + this.resid.ScopedResourceName("font")));
		resourceManager.Add(new FontResource(this.basepath + "resources/WildNature.ttf", "." + this.resid.ScopedResourceName("font")));
	}
}





class SevenForeverFreegame2BonusFactory_2Screen extends FreegameBonusFactory2
{
	public CreateFreegameBonus2_2Screen(gameName: ResourceIdentifier, freeGameConfig: FreegamesCommonConfiguration,  p: FreegameBonus2Params): FreegameBonus2 
	{
		return new SevenForever2Freegame_2Screen(gameName, freeGameConfig,  p);
	}
}

class SevenForeverSecondScreenHelpFactory extends SlideFactory
{
	public override CreateStyle():Partial<CSSStyleDeclaration>
	{
		let style :Partial<CSSStyleDeclaration> = 
		{
			color:"White"
		};
		return style;
	}
}
// }